import React, {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {useRole} from '@/hooks';
import {Routes} from '@/navigation/Routes';
import {SuperAdminDashboard} from './SuperAdminDashboard';
import PatientDashboard from './PatientDashboard';
import SpecialistDashboard from './SpecialistDashboard';
import {PatientAdminDashboard} from '../patient-admin-screens';
import {SpecialistAdminDashboard} from '../specialist-admin-screens';
import {HospitalAdminScreen} from './HospitalAdmin';
import {HospitalPocDashboard} from './HospitalPocDashboard';
import {SupportTickets} from '../support-admin-screens';

export const DashboardScreen: React.FC = () => {
  const {
    isSuperAdmin,
    isPatient,
    isSpecialist,
    isPatientAdmin,
    isFinanceAdmin,
    isSpecialistAdmin,
    isSupportAdmin,
    isHospitalAdmin,
    isHospitalPoc,
  } = useRole();
  const navigate = useNavigate();

  // Redirect finance admin to Patient Payments
  useEffect(() => {
    if (isFinanceAdmin) {
      navigate(Routes.PATIENT_PAYMENTS);
    }
  }, [isFinanceAdmin, navigate]);

  if (isSuperAdmin) {
    return <SuperAdminDashboard />;
  }
  if (isPatientAdmin) {
    return <PatientAdminDashboard />;
  }
  if (isSpecialistAdmin) {
    return <SpecialistAdminDashboard />;
  }
  if (isSupportAdmin) {
    return <SupportTickets />;
  }
  if (isPatient) {
    return <PatientDashboard />;
  }
  if (isSpecialist) {
    return <SpecialistDashboard />;
  }
  if (isHospitalAdmin) {
    return <HospitalAdminScreen />;
  }
  if (isHospitalPoc) {
    return <HospitalPocDashboard />;
  }
  return 'Dashboard';
};
